export default __webpack_public_path__ + "static/media/EconomicsSpendingSaving_06.78bbb3c6.png";